import Icon from 'vue-awesome/components/Icon.vue';
Icon.register({
  box: {
    width: 1546,
    height: 781,
    d: `M1514.6,99H31.4C14.1,99,0,84.9,0,67.6V31.4C0,14.1,14.1,0,31.4,0h1483.2c17.4,0,31.4,14.1,31.4,31.4v36.2
    	C1546,84.9,1531.9,99,1514.6,99z M49.5,194v546.5c0,22.3,18.1,40.5,40.5,40.5h1366.1c22.3,0,40.5-18.1,40.5-40.5V194H49.5z`,
  },
});
